// --- Physics Constants ---
export const GRAVITY_CONSTANT = 900; 
export const SHOT_POWER_MULTIPLIER = 100; 
export const AIM_POWER_SENSITIVITY_FACTOR = 1.0; 
export const TRAIL_MAX_LENGTH = 250; 
export const BALL_RADIUS = 8;

export const GAME_SPEED_MULTIPLIER = 1.8; 
export const PLAY_AREA_WIDTH = 2000;
export const PLAY_AREA_HEIGHT = 1500;

export const COLLISION_DAMPING = 0.75; 
export const MIN_SPEED_TO_HALVE_AFTER_COLLISION = 10.0; 
export const MIN_SPEED_TO_STOP_AFTER_COLLISION = 4.0;  
export const MIN_SPEED_TO_STOP_IN_SPACE = 2.0;
export const MIN_GRAVITY_MAGNITUDE_TO_KEEP_MOVING = 0.75;
export const SINK_ANIMATION_DURATION = 0.4; 
export const DYNAMIC_MAX_DRAG_FACTOR = 0.33; 
export const POWER_CURVE_SCALER = 18; 
export const MIN_DRAG_THRESHOLD_FACTOR = 0.18; 

// --- Zoom Parameters ---
export const MAX_VIEW_SCALE = 1.0; 
export const SCROLL_ZOOM_SENSITIVITY = 0.0007;
export const PINCH_ZOOM_SENSITIVITY = 1.0; 
export const ZOOM_RETURN_DELAY_MS = 700; 
export const SCROLL_GESTURE_TIMEOUT = 100; 
export const LERP_SPEED_SCALE = 0.15;
export const LERP_SPEED_CENTER = 0.12; 
export const LERP_SPEED_CENTER_RETURN = 0.08; 
export const VIEW_STABILITY_SCALE_THRESHOLD = 0.01;
export const VIEW_STABILITY_CENTER_THRESHOLD = 5;
export const INITIAL_COURSE_VIEW_DURATION_MS = 4000; 

// --- Space Bucks & Power-Ups Costs ---
export const ARCADE_STARTING_BUCKS = 0;
export const BUCKS_PER_UNDER_PAR_POINT = 5; 
export const POWERUP_COSTS = { 
    trajectoryLengthener: 45, 
    gravityGrid: 25, 
    stickyBall: 50, 
    linearLaser: 65,
    chronoRewind: 80,
    multiBall: 120,
    oobShield: 40
};

export const BASE_HOMING_FORCE = 80; 
export const MAX_HOMING_FORCE_BOOST = 300; 
export const HOMING_MAX_EFFECTIVE_DISTANCE = 500; 
export const HOMING_MIN_EFFECTIVE_DISTANCE_FACTOR = 2.5; 
export const HOMING_SURFACE_DAMP_FACTOR = 0.7; 

export const MULTI_BALL_COUNT = 3;
export const MULTI_BALL_SPREAD_ANGLE = 0.12; 
export const BUNKER_SHOT_POWER_REDUCTION = 0.7;

// --- Bunkers ---
export const BUNKER_CHANCE_PER_PLANET = 0.25;
export const MAX_BUNKERS_PER_PLANET = 1;
export const MIN_BUNKER_RADIUS_FACTOR = 0.40; 
export const MAX_BUNKER_RADIUS_FACTOR = 0.65; 
export const BUNKER_DEFAULT_WALL_THICKNESS = 3.0; 
export const BUNKER_COLOR_MAIN = '#D2B48C'; 
export const BUNKER_ESCAPE_GRACE_DURATION = 0.45; 
export const BUNKER_FLOOR_DEPTH_FRAC = 3.0;    
export const BUNKER_STICK_DEPTH_FRAC = 0.75;   
export const BUNKER_LATERAL_CHECK_GRACE_FRAC = 1.05; 
export const LAUNCH_ESCAPE_GRACE_DURATION = 0.15;


// --- Visual Colors & Palettes ---
export const PLANET_COLORS = [
    '#118AB2', 
    '#EF476F', 
    '#FFD166', 
    '#06D6A0', 
    '#1FA2FF', 
    '#A100FF', 
    '#F72585'
];
export const STAR_PARALLAX_FACTOR = 0.02; 
export const STAR_GENERATION_AREA_MULTIPLIER = 2.0; 

export const RANDOM_COURSE_ID = "Random Course"; 
export const ARCADE_MODE_ID = "Arcade Mode";

export const STICKY_BALL_DAMPING = 0.01; 
export const STICKY_BALL_RESTITUTION = 0; 
export const LEVEL_STORAGE_KEY = 'spaceGolfLevels';

// --- Sci-fi Naming Catalogs ---
export const SCIFI_PREFIXES = [
    "Zeta", "Xylo", "Nova", "Cryo", "Orion", "Alpha", "Mega", "Omega", "Terra", 
    "Astro", "Galacto", "Quasar", "Penta", "Hyper", "Robo", "Vortex", "Cyber", 
    "Exo", "Helio", "Cosmo", "Makka"
];
export const SCIFI_MIDDLES = [
    "Prime", "System", "Sector", "Nebula", "Cluster", "Point", "Station", 
    "Ridge", "Field", "Zone", "Core", "Vector", "Matrix", "Expanse", "Nexus", 
    "Frontier", "Drift", "Pass", "Caio"
];
export const SCIFI_SUFFIXES = [
    "VII", "IX", "Alpha", "Minor", "Major", "X", "Prime", "Zero", "Delta", 
    "Omega", "Core", "Hub", "Beacon", "Outpost", "Colony", "Terminal", "One", "Max"
];
